import React from 'react'

const Manual_agregar_link_encuesta_email = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Agregar link de encuesta en campañas de E-mail
        </h2>
        <iframe
          src="https://scribehow.com/embed/Agregar_link_de_encuesta_en_campanas_de_E-mail__V2ayPCU1QhKWcnw-PT3DRw?as=scrollable"
          className="scribe-iframe-general-78"
          width="100%"
          height="4100"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_agregar_link_encuesta_email
